/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Password_Reset_Email_RequiredInputs */

const en_password_reset_email_required = /** @type {(inputs: Password_Reset_Email_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email is required`)
};

const es_password_reset_email_required = /** @type {(inputs: Password_Reset_Email_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El correo electrónico es obligatorio`)
};

/**
* | output |
* | --- |
* | "Email is required" |
*
* @param {Password_Reset_Email_RequiredInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const password_reset_email_required = /** @type {((inputs?: Password_Reset_Email_RequiredInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Password_Reset_Email_RequiredInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_password_reset_email_required(inputs)
	return en_password_reset_email_required(inputs)
});